import PropTypes from 'prop-types'
import { isNilOrEmpty } from 'ramdasauce'

import { useStyles } from './styles'
import { PhotoTextItem } from 'components/molecules'
import { Animated } from 'components/atoms'

export const PhotoTextGrid = ({ data }) => {
  const classes = useStyles()

  const gridData = data.gridLayout

  const renderGrid =
    !isNilOrEmpty(gridData) &&
    gridData.map((item) => {
      const animationDirection = item.photoSide ? 'fade-left' : 'fade-right'
      return (
        <Animated type={animationDirection} key={item.id}>
          <div>
            <PhotoTextItem {...item} />
          </div>
        </Animated>
      )
    })

  return <div className={classes.wrapper}>{renderGrid}</div>
}

PhotoTextGrid.propTypes = {
  data: PropTypes.object,
}

PhotoTextGrid.defaultProps = {
  data: null,
}
